// Track B (realtime-inbox migration) — FE1.7 reconnect backoff schedule.
// growchat-doc/realtime-inbox/spec-websocket-conversation-migration.md
// growchat-doc/conversation-rollout/task-breakdown-conversation-rollout.md
//
// 1s -> 2s -> 4s -> 8s, capped at 15s, then every 30s thereafter. `attempt`
// is 1-based: the first reconnect attempt after a disconnect uses
// RECONNECT_DELAYS_MS[0], the second RECONNECT_DELAYS_MS[1], etc. Once past
// the ramp, every further attempt waits STEADY_STATE_DELAY_MS — this is what
// keeps a WS-unavailable client (backend flag off, network blocked, etc.)
// from hammering POST /manager/{tenantId}/ws-ticket.
export const RECONNECT_DELAYS_MS = [1000, 2000, 4000, 8000, 15000]
export const STEADY_STATE_DELAY_MS = 30000

export function getReconnectDelayMs(attempt) {
  const index = attempt - 1
  if (index >= 0 && index < RECONNECT_DELAYS_MS.length) return RECONNECT_DELAYS_MS[index]
  return STEADY_STATE_DELAY_MS
}
